import { Component, HostBinding, OnInit } from '@angular/core'
import { AbstractControl, UntypedFormArray, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms'
import { ActivatedRoute, Router } from '@angular/router'
import { NotificationService } from '../../../../notification/shared/notification.service'
import { ArticleRequest } from '../../../basket/shared/article-request'
import { BasketService } from '../../../basket/shared/basket.service'

@Component({
    selector: 'app-porteur-add',
    templateUrl: './porteur-add.component.html',
    styleUrls: ['./porteur-add.component.scss']
})
export class PorteurAddComponent implements OnInit {
    @HostBinding('class.clamp') clamp = true

    formGroup: UntypedFormGroup
    breakpoint

    constructor(
        private basketService: BasketService,
        private notificationService: NotificationService,
        private router: Router,
        private route: ActivatedRoute
    ) {
    }

    ngOnInit() {
        this.formGroup = new UntypedFormGroup({
            'identity': new UntypedFormGroup({}),
            'dotation': new UntypedFormArray([]),
            'nbDotation': new UntypedFormControl('', validateDotation),
        })
        this.onResize(window.innerWidth)
    }

    onResize(event) {
        const x = event
        switch (true) {
            case (x <= 968):
                this.breakpoint = 1
                break
            case (x >= 968 && x <= 1400):
                this.breakpoint = 2
                break
            case (x >= 1400 && x <= 1900):
                this.breakpoint = 3
                break
            case (x > 1900):
                this.breakpoint = 4
                break
            default:
                this.breakpoint = 4
                break
        }
    }

    closeControl(control: AbstractControl) {
        this.dotation.removeAt(this.dotation.controls.indexOf(control))
        this.formGroup.get('nbDotation').setValue('')
    }

    get identity(): AbstractControl {
        return this.formGroup.get('identity')
    }

    get dotation(): UntypedFormArray {
        return this.formGroup.get('dotation') as UntypedFormArray
    }

    get nbDotation(): UntypedFormControl {
        return this.formGroup.get('nbDotation') as UntypedFormControl
    }

    success() {
        this.notificationService.notif("Votre demande d'ajout d'utilisateur a été ajoutée au panier. Elle sera automatiquement supprimée sous 2 jours si elle n'est pas validée.", 'notif');
        this.router.navigate(['../porteurs'], {
            relativeTo: this.route
        })
    }

    submitForm() {
        if (this.formGroup.valid) {
            this.basketService.addBasketLine({
                type: "AJOUT PORTEUR",
                identity: {
                    firstname: this.identity.get('firstname').value,
                    lastname: this.identity.get('lastname').value,
                    function: this.identity.get('function').value,
                    casier: this.identity.get('casier').value,
                    comment: this.identity.get('comment').value,
                },
                articles: this.dotation.controls.map<ArticleRequest>(control => {
                    return {
                        article: control.get('article').value.code_article as string,
                        taille: control.get('taille').value.libelle_long as string,
                        retouche: control.get('retouche').value as string,
                        qteSouhaite: control.get('qteSouhaite').value as string,
                        change:
                            control.get('change').value.qte_semaine +
                            '/' + control.get('change').value.qte_prevue +
                            '|' + control.get('change').value.multi_change as string,
                        regleFactu: control.get('change').value.type_facturation.cle_ref
                    }
                })
            }).subscribe(res => this.success())
        }
    }


    addArticle() {
        if (this.dotation.valid) {
            this.dotation.push(new UntypedFormGroup({
                'article': new UntypedFormControl('', [
                    Validators.required
                ]),
                'taille': new UntypedFormControl('', [
                    Validators.required
                ]),
                'change': new UntypedFormControl('', [
                    Validators.required
                ]),
                'retouche': new UntypedFormControl('', [
                ]),
                'qteSouhaite': new UntypedFormControl('', [
                ]),
            })
            )
        } else {
            this.notificationService.notif(
                "Certains champs de vos vêtements déjà ajoutés sont incorrects ou incomplets, " +
                "veuillez les corriger avant d'ajouter un nouveau vêtement.",
                "warn"
            )
        }
        this.formGroup.get('nbDotation').setValue('')
    }
}

function validateDotation(c: UntypedFormControl) {

    if (typeof c.root.value.dotation !== 'undefined') {
        if (c.root.value.dotation.length >= 1) {
            return null
        }
        else {
            return {
                validateDotation: {
                    valid: false
                }
            }
        }
    }
    else {
        return {
            validateDotation: {
                valid: false
            }
        }
    }
}
